export default __webpack_public_path__ + "static/media/logo-3.b7ee4ec2.png";